<template>
    <div class="users">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>使用信息</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem 0 1rem; background-color: white">
            <el-form :inline="true" :model="query">
                <el-form-item label="账户名">
                    <el-input v-model="query.phone" placeholder="账户名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onQuery">查询</el-button>
                    <el-button type="default" @click="query = {}">重置</el-button>
                    <el-button type="default" @click="exportExcel">导出表格</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin-top: 1rem; padding: 1rem; background-color: white">
            <el-table
                    :data="devices"
                    border
                    stripe
                    v-loading="loading"
                    style="width: 100%">
                <el-table-column
                        sortable
                        prop="phone"
                        label="账户名">
                </el-table-column>
                <el-table-column
                        sortable
                        :sort-method="(a, b) => a.deviceName ? a.deviceName.localeCompare(b.deviceName, 'zh') : -1"
                        prop="deviceName"
                        label="设备名称">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="deviceModel"
                        label="设备型号">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="doStart"
                        label="是否开机">
                    <template slot-scope="scope">
                        {{scope.row.doStart == 0 ? "未开机" : "已开机"}}
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="useTime"
                        label="使用时间">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="location"
                        label="使用位置">
                </el-table-column>
            </el-table>
            <div style="text-align: center">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pagination.page"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import deviceApi from "../../api/deviceType";
    import enterpriseApi from "../../api/enterprise";
    import useinfoApi from "../../api/useinfo";
    import {mapState} from "vuex";

    export default {
        data: function () {
            return {
                devices: [],
                enterprises: [],
                loading: false,
                total: 0,
                pagination: {
                    page: sessionStorage.getItem("page") || 1,
                    pageSize: 10
                },
                query: {

                },
            }
        },
        computed: {
            ...mapState("auth", {
                auth: state => state
            }),
        },
        mounted() {
            this.loadUsers();
        },
        methods: {
            loadUsers: function () {
                this.loading = true;
                useinfoApi.getAll(this.query, this.pagination).then(result => {
                    this.loading = false;
                    this.devices = result.data;
                    this.total = result.total;
                })
            },
            onQuery: function () {
                this.pagination = {
                    page: 1,
                    pageSize: 10
                }
                this.loadUsers();
            },
            handleSizeChange: function (size) {
                this.pagination = {
                    page: 1,
                    pageSize: size
                }
                this.loadUsers();
            },
            handleCurrentChange: function (page) {
                sessionStorage.setItem("page", page);
                this.pagination = {
                    ...this.pagination,
                    page: page,
                }
                this.loadUsers();
            },
            exportExcel: function () {
                location.href = "/admin/useinfo/export";
            }
        }
    }
</script>
